/**
 * Import constants
 */
import { GET_RECIPIENTS_DATA, GET_RECIPIENTS_DATA_PENDING, GET_RECIPIENTS_DATA_ERROR } from '../actions/constants';

/**
 * Initial state
 */
const initialState = {
	loading: true,
	data: {},
	error: null
};

/**
 * Recipients engagement reducer
 * @param {*} state
 * @param {*} action
 */
export const recipientsEngagementReducer = (state = initialState, action) => {
	switch (action.type) {
		case GET_RECIPIENTS_DATA_PENDING:
			return {
				...state,
				loading: true
			};
		case GET_RECIPIENTS_DATA:
			return {
				...state,
				loading: false,
				data: Object.assign({}, state.data, action.payload),
				error: null
			};
		case GET_RECIPIENTS_DATA_ERROR:
			return {
				...state,
				loading: true,
				error: action.payload
			};
		default:
			return state;
	}
};
